<template>
	<vx-tooltip :text="getToolTipText()">
		<vs-button color="primary" @click.native="printShippingLabel" :disabled="isButtonDisabled()">
			<font-awesome-icon :icon="['fas', 'print']" class="fa-icon" />
		</vs-button>
	</vx-tooltip>
</template>

<script>

import dymoLabels from '@/services/dymo/dymoLabels';
import dymoPrinter from '@/services/dymo/dymoPrinter';

export default {
	name: 'printShippingLabel',
	props: {
		order: {
			type: Object,
			required: true,
		},
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
	methods: {
		getToolTipText() {
			if (!this.dymoPrinter.shippingPrinterReady()) {
				return 'Er is geen verbinding met de adres label printer';
			}

			return 'Print adres label';
		},
		isButtonDisabled() {
			return !this.dymoPrinter.shippingPrinterReady();
		},
		printShippingLabel() {
			const shippingLabel = dymoLabels.createAddressLabelForOrderAddress(this.order.shipping);

			this.dymoPrinter.printShippingLabel(this.order);
		},
	}
}
</script>
